module.exports = __webpack_public_path__ + "assets-cabinet/img/key-ico.8bf35a80.svg";